import React, { FunctionComponent } from 'react'

export interface Props {
  title: string | null
  value: string | null
}

const LoanOverviewRow: FunctionComponent<Props> = ({ title, value }) => {
  return (
    <div className="loan-details__row">
      <span>{title}</span>
      <span className="loan-details__value">{value}</span>
    </div>
  )
}

export default LoanOverviewRow
